import  { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import HeaderDropdown from "./HeaderDropdown/HeaderDropdown";
import amitimLogo from "../../assets/images/Amitim_Logo_Slogan.svg";
import homeIcon from "../../assets/images/header/home-nev.svg";
import greenHomeIcon from "../../assets/images/header/home-g.svg";
import emailIcon from "../../assets/images/header/letter-nev.svg";
import emailIconRed from "../../assets/images/letter-nev-red.svg";
import emailIconRedBlue from "../../assets/images/letter-nev-blue-red.svg";
import greenEmailIcon from "../../assets/images/header/letter-g.svg";
import profileIcon from "../../assets/images/header/user-nev.svg";
import greenProfileIcon from "../../assets/images/header/user-g.svg";
import depositIcon from "../../assets/images/header/deposits-nev.svg";
import greenDepositIcon from "../../assets/images/header/deposits-g.svg";
import actionsIcon from "../../assets/images/header/actions-nev.svg";
import actionsGreenIcon from "../../assets/images/header/actions-g.svg";
import callIcon from "../../assets/images/header/call-nev.svg";
import greenCallIcon from "../../assets/images/header/call-g.svg";
import message from "../../assets/images/message.png";
import { useTranslation } from "react-i18next";
import logoMobile from "../../assets/images/Amitim_Logo_Slogan.svg";
import { useSelector } from "react-redux";
import HeaderItem from "./HeaderItem/HeaderItem";
import { isEnterPress } from "../../utils/helpers/accessibilityUtil";
import Drawerui from "../Drawer/Drawer";
import "./Header.scss";
import HeaderActionsItem from "./HeaderActionsItem/HeaderActionsItem";
import { Button } from "@mui/material";
import "../../assets/scss/variables.scss";
import useWindowDimensions from "../../customHooks/useWindowDimensions";
import { headerSzie, screenSzie } from "../../utils/main";

const Header = () => {
  const location = useLocation();
  const history = useHistory();
  const { isAmit, haveMessages } = useSelector(
    (state: any) => state.UserReducer
  );
  const { showAmitFundMobile, showGimlaiFundMobile } = useSelector(
    (state: any) => state.DashboardReducer
  );
  const { width } = useWindowDimensions();
  const isMobile = (width < screenSzie.tablet); 
  const { t, i18n } = useTranslation("common");
  const [lang, setLang] = useState(
    localStorage.getItem("lang") ? localStorage.getItem("lang") : "he"

  );

  useEffect(() => {}, [location]);

  const handleChange = (e: any) => {
    window.location.reload();
    localStorage.setItem("lang", e.target.value);
    document.documentElement.lang =e.target.value; 
    if(location.pathname != "/deposits"){
      i18n.changeLanguage(e.target.value)
    }
  };

  const renderMiniHeader = () =>
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/privacy-questions";
    

  return (
    <header>
      {renderMiniHeader() ? (
        <div
          className="bottom d-flex align-items-center justify-content-space-between wrap-mini-header"
          style={{ height: 90 }}
        >
          <a
            className="header-right"
            target="_blank"
            href={"https://www.amitim.com"}>
            <img
              src={amitimLogo}
              className="amitim-logo"
              alt={t("header.imgalt")}
            />
          </a>
          {/* <div className="d-flex">
            <Button variant="text" className={localStorage.getItem("lang")=== "he"  ? "btn active" : "btn"}   onClick={handleChange} value={"he"}>{t("header.hebrew")}</Button>
            <Button variant="text" className={localStorage.getItem("lang")=== "ar" ? "btn active" : "btn"}  onClick={handleChange} value={"ar"}>{t("header.arabic")}</Button>
          </div> */}
        </div>
      ) : (
        <>
          <div
            id="top-header"
            className={
              showAmitFundMobile || showGimlaiFundMobile
                ? "top d-flex align-items-center justify-content-end hide-top-header"
                : "top d-flex align-items-center justify-content-end"
            }
          >
            <img
              className="mobile-da logo-icon-h"
              src={logoMobile}
              alt=""
              onClick={() => history.push("/")}
            />
            <div className="d-flex align-items-center btn-rap-header">

      {!isMobile ?(
        haveMessages ? (
          <div
            className="d-flex align-items-center"
            onClick={() => history.push("/reports")}
            onKeyPress={(event) =>
              isEnterPress(event) && history.push("/reports")
            }
            tabIndex={0}
          >
            <span className="header-left-text-messages">
            <div className="header-left-text-messages-t"> {t("header.messages")}</div> 
              <img src={message} alt="" />
            </span>
           
          </div>
        ) : null
  
        

      ) : null    
      }

              



          {/* <div>
          <Button
            className={localStorage.getItem("lang")=== "he" ? "btn-h active" : "btn-h"}
            onClick={handleChange} value={"he"}>
            {t("header.hebrew")}
          </Button>
          <Button 
            className={localStorage.getItem("lang")=== "ar" ? "btn-h active" : "btn-h"}
            onClick={handleChange} value={"ar"}>
              {t("header.arabic")}
          </Button>
        </div> */}
         </div>
         <div className="d-flex align-items-center btn-rap-header">
              <HeaderDropdown />
              <div
                className="mobile-da"
              >
                <Drawerui />
              </div>
           </div>
          </div>
          <div id="bottom-header" className="bottom d-flex align-items-center">
          {/* aria-labelledby="sections-heading" */}
            <div  
            className="header-right" 
            role="navigation"
            aria-label="תפריט ראשי">
            {!isMobile ?
              <a
               href={"https://www.amitim.com"}
               target="_blank">
              <img
                onKeyPress={(event) => history.push("/")}
                src={amitimLogo}
                className="amitim-logo"
                alt={t("header.imgalt")}
              />
              </a>: null}

              <HeaderItem
                image={homeIcon}
                greenImage={greenHomeIcon}
                text={t("header.homePage")}
                path={"/"}
                activePath={location.pathname.toString()}
                alt={"home"}
              />

              <HeaderItem
                image={profileIcon}
                greenImage={greenProfileIcon}
                text={t("header.personalDetails")}
                path={"/my-details"}
                activePath={location.pathname.toString()}
                alt={"profile"}
              />

             {isMobile ? <HeaderItem
                image={haveMessages ? emailIconRed : emailIcon}
                greenImage={haveMessages ? emailIconRedBlue : greenEmailIcon}
                text={t("header.repots")}
                path={"/reports"}
                activePath={location.pathname.toString()}
                alt={"email"}
              />
              : <HeaderItem
                image={emailIcon}
                greenImage={greenEmailIcon}
                text={t("header.repots")}
                path={"/reports"}
                activePath={location.pathname.toString()}
                alt={"email"}
             />}
              

              {isAmit ? (
                <HeaderItem
                  image={depositIcon}
                  greenImage={greenDepositIcon}
                  text={t("header.deposits")}
                  path={"/deposits"}
                  activePath={location.pathname.toString()}
                  alt={"reports"}
                />
              ) : null}

              {width > headerSzie.m ? 
              <HeaderActionsItem
                image={actionsIcon}
                greenImage={actionsGreenIcon}
                text={t("header.actions")}
              /> : null }

              <HeaderItem
                image={callIcon}
                greenImage={greenCallIcon}
                text={t("header.contact")}
                path={"/contact"}
                activePath={location.pathname.toString()}
                alt={"call-icon"}
              />
            </div >
          </div>
        </>
      )}
    </header>
  );
};

export default Header;